import React, { useState } from 'react';
import { Snackbar as MaterialSnackbar, SnackbarContent, IconButton } from '@mui/material';
import { Close as CloseIcon, CheckCircle as CheckCircleIcon, Error as ErrorIcon, Info as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

import Button from 'components/ui/button';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const Snackbar = ({
  buttonTitle,
  message,
  isOpen,
  onClick,
  onClose,
  closable,
  autoHideDuration,
  vertical,
  horizontal,
  variant,
  width,
  ...props
}) => {
  const [open, setOpen] = useState(isOpen);
  const Icon = variantIcon[variant];

  function handleClick() {
    onClick && onClick();
    setOpen(false);
  }

  function handleClose(event, reason) {
    if (reason !== 'clickaway') {
      setOpen(false);
    }
    onClose && onClose(reason);
  }

  const actions = [];
  if (buttonTitle) {
    actions.push((
      <Button key="button" size="small" style={{ padding: '4px 8px', minHeight: '38px', minWidth: '55px', borderRadius: 6 }} onClick={handleClick}>
        {buttonTitle}
      </Button>
    ));
  }
  if (closable) {
    actions.push(
      <IconButton
        key="close"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
        size="large">
        <CloseIcon style={{ fontSize: '20px' }}/>
      </IconButton>
    )
  }

  return (
    <MaterialSnackbar
      anchorOrigin={{
        vertical,
        horizontal
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      style={{ width: width ? `${width}px` : 'auto', maxWidth: 'calc(100% - 18px)' }}
      {...props}
    >
      <SnackbarContent
        aria-describedby="snackbar-id"
        style={{ flexWrap: 'inherit' }}
        message={
          <span id="snackbar-id" style={{ display: 'flex', alignItems: 'center' }}>
            {variant && variantIcon[variant] &&
              <Icon style={{ fontSize: '20px', opacity: 0.9, marginRight: 10 }} />
            }
            {message}
          </span>
        }
        action={actions}
      />
    </MaterialSnackbar>
  );
}


Snackbar.propTypes = {
  message: PropTypes.node.isRequired,
  buttonTitle: PropTypes.string,
  vertical: PropTypes.string,
  horizontal: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  closable: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  width: PropTypes.number,
  variant: PropTypes.string
};

Snackbar.defaultProps = {
  buttonTitle: null,
  onClick: undefined,
  onClose: undefined,
  isOpen: true,
  closable: false,
  autoHideDuration: undefined,
  vertical: 'bottom',
  horizontal: 'right',
  variant: '',
  width: undefined
};

export default Snackbar;